export const creditCard = {
  
  create: 'crm/v3/customer/creditCard/createv2',
  get: 'customerEndpoint/creditCard',
  tokenization: 'orderEndpoint/cardTokenization',
  default: 'customerEndpoint/defaultCard',
  delete: 'customerEndpoint/deleteCreditCard',
  validateOrders: 'orderEndpoint/validateOrders',
  deleteCreditCard: 'customerEndpoint/deleteCreditCard',
  bin: 'validateBin',
};
